module.exports = __webpack_public_path__ + "static/img/logo3.a91be3e7.png";